import { normalizeWorkType } from '../utils/catalogDisplay';
function mapSegment(seg) {
    return {
        segId: seg.id,
        stage: seg.stage,
        start: seg.start,
        len: seg.len,
        ...(seg.label ? { label: seg.label } : {}),
    };
}
function mapProject(p, sectionId) {
    return {
        id: String(p.id),
        sectionId,
        title: p.title,
        type: normalizeWorkType(p.type) || (p.type ?? ''),
        priority: p.priority ?? '',
        stake: p.stakeholders ?? '',
        effect: p.effect ?? '',
        effectComment: p.effectComment ?? '',
        effort: p.effort ?? '',
        duration: p.duration ?? '',
        deps: p.dependencies ?? '',
        ab: p.abTest ?? '',
        comment: p.comment ?? '',
        runLabel: p.runLabel ?? '',
        segs: (p.segs ?? []).map(mapSegment),
    };
}
export function mapBoardFullToSheet(full) {
    const teams = full.teams.map((team) => ({
        id: team.id,
        name: team.name,
        sections: team.sections.map((sec) => ({
            id: sec.id,
            name: sec.name || null,
            color: sec.color,
            projects: sec.projects.map((p) => mapProject(p, sec.id)),
        })),
    }));
    return {
        boardId: full.id,
        title: full.title,
        weekStart: full.weekStart,
        weeksCount: full.weeksCount,
        year: full.year,
        quarter: full.quarter,
        teams,
    };
}
export function indexProjects(sheet, byId) {
    sheet.teams.forEach((t) => t.sections.forEach((sec) => sec.projects.forEach((p) => {
        byId[p.id] = p;
    })));
}
